import React from 'react'
import { Row, Col } from 'reactstrap'
import InstanceSearchInput from './InstanceSearchInput'
import InstanceSearchButton from './InstanceSearchButton'
import InstancesRefreshButton from './InstancesRefreshButton'
import InstancesPageSizeSelect from './InstancesPageSizeSelect'

function InstancesToolbar({
  pageSize,
  onPageSizeChange,
  onRefresh,
  searchValue,
  onSearchChange,
  onSearch,
}) {
  return (
    <Row className="mb-3">
      <Col xs="12" md="8" lg="5">
        <div className="instances-search-group">
          <InstanceSearchInput value={searchValue} onChange={onSearchChange} onSearch={onSearch}/>
         
        </div>
      </Col>
      <Col xs="12" md="3" lg="3">
        <InstancesRefreshButton onRefresh={onRefresh} />
      </Col>
      <Col xs="12" md="3" lg="4">
        <InstancesPageSizeSelect
          pageSize={pageSize}
          onPageSizeChange={onPageSizeChange}
        />
      </Col>
    </Row>
  )
}

export default InstancesToolbar
